'use client'

import { useEffect } from 'react'
import { useCapacitorBridge } from '@/components/capacitor-bridge-provider'
import { useCookieConsent } from '@/hooks/use-cookie-consent'
import {
  denyConsent as denyGoogleConsent,
  grantConsent as grantGoogleConsent,
  initGoogleAnalytics,
} from '@/lib/google-analytics'

/**
 * Google Ads con Consent Mode v2: se carga siempre (default `denied`) y sigue
 * al consentimiento guardado. Lo usa `CookieConsentProvider` en toda la web y,
 * en las rutas sensibles que `AnalyticsBoundary` deja sin provider, quien tenga
 * que medir algo allí (la conversión de la entrega). La ubicación que ve Google
 * en esas rutas la decide `lib/google-analytics` con la política de URLs.
 *
 * En la app nativa no se carga (App Store Guideline 5.1.2(i), ATT).
 */
export function useGoogleConsentMode(): void {
  const { consentStatus, isLoading } = useCookieConsent()
  const { isNativeApp } = useCapacitorBridge()

  useEffect(() => {
    if (isNativeApp) return
    initGoogleAnalytics()
  }, [isNativeApp])

  useEffect(() => {
    if (isNativeApp || isLoading) return

    if (consentStatus === 'accepted') {
      grantGoogleConsent()
    } else if (consentStatus === 'rejected') {
      denyGoogleConsent()
    }
  }, [consentStatus, isLoading, isNativeApp])
}
